import { Request } from './../Shared/Request';

export class Hours {
    constructor(config) {
        this.request = new Request();
        this.url = config.url;
    }

    getHours() {
        return this.request.get(this.url).then((resp) => {
            return JSON.parse(resp);
        })
    }
}



// WEBPACK FOOTER //
// ./src/modules/Hours/index.js